/* deploy: re-sync full script (PDP sticky-header/buy-bar hooks) v2 */
/* ============================================================
   LIQUID STRENGTH — interactions
   All guarded; no errors if an element is missing.
   ============================================================ */
(function () {
  "use strict";

  var prefersReduced = window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- 1. MOBILE NAV TOGGLE ---------- */
  (function mobileNav() {
    var toggle = $("#navToggle");
    var menu = $("#mobileMenu");
    if (!toggle || !menu) return;

    // Background regions to hide from AT / keyboard while the overlay is open.
    // The header is deliberately excluded: it holds the close (X) toggle and the
    // logo, which must stay clickable while the menu is open.
    var backgrounds = [$("main"), $(".footer")].filter(Boolean);

    function focusableIn(el) {
      return $$("a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex='-1'])", el)
        .filter(function (node) { return node.offsetParent !== null || node === document.activeElement; });
    }

    function setBackgroundInert(on) {
      backgrounds.forEach(function (el) {
        if (on) {
          el.setAttribute("aria-hidden", "true");
          if ("inert" in HTMLElement.prototype) el.inert = true;
        } else {
          el.removeAttribute("aria-hidden");
          if ("inert" in HTMLElement.prototype) el.inert = false;
        }
      });
    }

    function setOpen(open) {
      toggle.setAttribute("aria-expanded", String(open));
      toggle.setAttribute("aria-label", open ? "Close menu" : "Open menu");
      if (open) {
        menu.hidden = false;
        document.body.style.overflow = "hidden";
        setBackgroundInert(true);
        var first = focusableIn(menu)[0];
        if (first) first.focus();
      } else {
        menu.hidden = true;
        document.body.style.overflow = "";
        setBackgroundInert(false);
      }
    }

    toggle.addEventListener("click", function () {
      setOpen(toggle.getAttribute("aria-expanded") !== "true");
    });

    $$(".mobile-link, .mobile-menu__cta", menu).forEach(function (link) {
      link.addEventListener("click", function () {
        setOpen(false);
        toggle.focus();
      });
    });

    // Logo / brand returns home (href="#top") and closes the menu if it is open.
    var brand = $(".site-header .brand");
    if (brand) {
      brand.addEventListener("click", function () {
        if (toggle.getAttribute("aria-expanded") === "true") setOpen(false);
      });
    }

    // Focus trap + Escape, scoped to the menu while it is open.
    menu.addEventListener("keydown", function (e) {
      if (toggle.getAttribute("aria-expanded") !== "true") return;

      if (e.key === "Escape") {
        setOpen(false);
        toggle.focus();
        return;
      }

      if (e.key !== "Tab") return;
      var items = focusableIn(menu);
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    // Escape from anywhere (e.g. focus briefly outside) still closes.
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && toggle.getAttribute("aria-expanded") === "true") {
        setOpen(false);
        toggle.focus();
      }
    });
  })();

  /* ---------- 2. STICKY HEADER CONDENSE ---------- */
  (function stickyHeader() {
    var header = $("#siteHeader");
    var hero = $(".hero") || $(".ls-pdp__hero");
    if (!header) return;

    // Condense when the hero has (mostly) scrolled past.
    var threshold = hero ? Math.max(hero.offsetHeight - 90, 80) : 120;

    function onScroll() {
      var condensed = window.scrollY > threshold;
      header.setAttribute("data-condensed", String(condensed));
      header.setAttribute("data-over-dark", String(!condensed));
    }
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", function () {
      threshold = hero ? Math.max(hero.offsetHeight - 90, 80) : 120;
      onScroll();
    });
  })();

  /* ---------- 3. SCROLL REVEAL (IntersectionObserver) ---------- */
  (function scrollReveal() {
    var els = $$(".reveal");
    if (!els.length) return;

    if (prefersReduced || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("is-visible"); });
      return;
    }

    // Stagger siblings sharing the same parent.
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var siblings = el.parentElement ? $$(".reveal", el.parentElement) : [el];
        var idx = siblings.indexOf(el);
        var delay = idx > 0 ? Math.min(idx * 70, 350) : 0;
        setTimeout(function () { el.classList.add("is-visible"); }, delay);
        io.unobserve(el);
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });

    els.forEach(function (el) { io.observe(el); });
  })();

  /* ---------- 4. FAQ ACCORDION (one open at a time) ---------- */
  (function faq() {
    var triggers = $$(".faq__trigger");
    if (!triggers.length) return;

    function close(btn) {
      var panel = document.getElementById(btn.getAttribute("aria-controls"));
      btn.setAttribute("aria-expanded", "false");
      if (panel) animatePanel(panel, false);
    }

    function open(btn) {
      var panel = document.getElementById(btn.getAttribute("aria-controls"));
      btn.setAttribute("aria-expanded", "true");
      if (panel) animatePanel(panel, true);
    }

    function animatePanel(panel, show) {
      if (show) {
        panel.hidden = false;
        if (prefersReduced) return;
        var h = panel.scrollHeight;
        panel.style.height = "0px";
        panel.style.opacity = "0";
        // force reflow
        void panel.offsetHeight;
        panel.style.transition = "height .24s ease-out, opacity .24s ease-out";
        panel.style.height = h + "px";
        panel.style.opacity = "1";
        panel.addEventListener("transitionend", function te() {
          panel.style.height = "";
          panel.style.transition = "";
          panel.removeEventListener("transitionend", te);
        });
      } else {
        if (prefersReduced) { panel.hidden = true; return; }
        var cur = panel.scrollHeight;
        panel.style.height = cur + "px";
        void panel.offsetHeight;
        panel.style.transition = "height .22s ease-out, opacity .22s ease-out";
        panel.style.height = "0px";
        panel.style.opacity = "0";
        panel.addEventListener("transitionend", function te() {
          panel.hidden = true;
          panel.style.height = "";
          panel.style.opacity = "";
          panel.style.transition = "";
          panel.removeEventListener("transitionend", te);
        });
      }
    }

    triggers.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var isOpen = btn.getAttribute("aria-expanded") === "true";
        if (isOpen) {
          close(btn);
        } else {
          triggers.forEach(function (other) {
            if (other !== btn && other.getAttribute("aria-expanded") === "true") close(other);
          });
          open(btn);
        }
      });
    });
  })();

  /* ---------- 5. VARIANT / COLOURWAY SELECTOR ---------- */
  (function variants() {
    var swatches = $$(".swatch");
    if (!swatches.length) return;

    var img = $("#variantImg");
    var nameEl = $("#variantName");
    var taglineEl = $("#variantTagline");
    var descEl = $("#variantDesc");
    var buyNameEl = $("#variantBuyName");
    var bestEl = $("#variantBest");
    var indexEl = $("#variantIndex");
    var ctaEl = $("#variantCta");
    var priceEl = $("#variantPrice");
    var root = $("#variants");

    function hexToRgba(hex, a) {
      var h = hex.replace("#", "");
      if (h.length === 3) h = h.split("").map(function (c) { return c + c; }).join("");
      var n = parseInt(h, 16);
      return "rgba(" + ((n >> 16) & 255) + "," + ((n >> 8) & 255) + "," + (n & 255) + "," + a + ")";
    }

    // Preload colourway photos for instant swaps.
    swatches.forEach(function (s) {
      if (s.dataset.img) { var p = new Image(); p.src = s.dataset.img; }
    });

    function setDims(w, h) {
      if (!img) return;
      if (w) img.setAttribute("width", w);
      if (h) img.setAttribute("height", h);
    }

    function swapImage(src, alt, w, h) {
      if (!img) return;
      if (prefersReduced) { img.src = src; img.alt = alt; setDims(w, h); return; }
      img.classList.add("is-swapping");
      var done = false;
      var apply = function () {
        if (done) return; done = true;
        img.src = src; img.alt = alt; setDims(w, h);
        requestAnimationFrame(function () { img.classList.remove("is-swapping"); });
      };
      setTimeout(apply, 180);
    }

    function select(btn) {
      swatches.forEach(function (s) {
        var active = s === btn;
        s.classList.toggle("is-active", active);
        s.setAttribute("aria-checked", String(active));
      });

      var d = btn.dataset;
      swapImage(d.img, d.alt || ("Liquid Strength in " + d.name), d.w, d.h);
      if (nameEl) nameEl.textContent = d.name;
      if (taglineEl) taglineEl.textContent = d.tagline;
      if (descEl) descEl.textContent = d.desc;
      if (buyNameEl) buyNameEl.textContent = d.name;
      if (ctaEl && d.url) ctaEl.setAttribute("href", d.url);
      if (priceEl && d.price) priceEl.textContent = d.price;
      if (bestEl) bestEl.textContent = d.best || "";
      if (indexEl) indexEl.textContent = d.index || "";
      if (root) {
        if (d.cw) root.style.setProperty("--cw", d.cw);
        if (d.cwbtn) root.style.setProperty("--cwbtn", d.cwbtn);
        root.style.setProperty("--cw-soft", hexToRgba(d.cw || d.hex, 0.5));
      }
    }

    swatches.forEach(function (btn) {
      btn.addEventListener("click", function () { select(btn); });
    });

    // Keyboard arrow navigation across the radiogroup.
    var group = $(".swatches");
    if (group) {
      group.addEventListener("keydown", function (e) {
        if (["ArrowRight", "ArrowDown", "ArrowLeft", "ArrowUp"].indexOf(e.key) === -1) return;
        e.preventDefault();
        var current = swatches.indexOf(document.activeElement);
        if (current === -1) current = swatches.findIndex(function (s) { return s.classList.contains("is-active"); });
        var next = (e.key === "ArrowRight" || e.key === "ArrowDown")
          ? (current + 1) % swatches.length
          : (current - 1 + swatches.length) % swatches.length;
        swatches[next].focus();
        select(swatches[next]);
      });
    }
  })();

  /* ---------- 6. STAT COUNT-UP ---------- */
  (function counters() {
    var stats = $$("[data-count]");
    if (!stats.length) return;

    function format(el, value) {
      var prefix = el.dataset.prefix || "";
      var suffix = el.dataset.suffix || "";
      el.textContent = prefix + value + suffix;
    }

    function run(el) {
      var target = parseInt(el.textContent.replace(/[^\d]/g, ""), 10);
      if (isNaN(target)) return;
      if (prefersReduced) { format(el, target); return; }

      var duration = 850;
      var start = null;
      function tick(ts) {
        if (start === null) start = ts;
        var p = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - p, 3); // ease-out cubic
        format(el, Math.round(target * eased));
        if (p < 1) requestAnimationFrame(tick);
        else format(el, target);
      }
      requestAnimationFrame(tick);
    }

    if (prefersReduced || !("IntersectionObserver" in window)) {
      stats.forEach(run);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          run(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });

    stats.forEach(function (el) { io.observe(el); });
  })();

  /* ---------- 7. STICKY MOBILE BUY BAR ---------- */
  (function buyBar() {
    var bar = $("#buyBar");
    // Landing: track the tall hero. PDP: track the in-page Add-to-cart button, so the sticky
    // bar shows whenever that button is off-screen (i.e. an add-to-cart is always one tap away).
    var hero = $(".hero") || $(".ls-pdp__add");
    if (!bar || !hero) return;

    if (!("IntersectionObserver" in window)) { return; }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        // Show the bar once the hero is out of view.
        bar.classList.toggle("is-visible", !entry.isIntersecting);
        bar.setAttribute("aria-hidden", String(entry.isIntersecting));
      });
    }, { threshold: 0, rootMargin: "-60px 0px 0px 0px" });

    io.observe(hero);
  })();

  /* ---------- 8. NEWSLETTER (front-end only) ---------- */
  (function newsletter() {
    var form = $("#newsletterForm");
    var input = $("#newsletterEmail");
    var msg = $("#newsletterMsg");
    if (!form || !input || !msg) return;

    // Validate client-side only. On a valid email we let the form submit natively to
    // Shopify's customer endpoint (which reloads and shows the server success state).
    form.addEventListener("submit", function (e) {
      var val = input.value.trim();
      var ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
      if (!ok) {
        e.preventDefault();
        msg.classList.add("newsletter__msg--err");
        msg.textContent = "Please enter a valid email address.";
        input.focus();
        return;
      }
      msg.classList.remove("newsletter__msg--err");
      msg.textContent = "";
    });
  })();

  /* ---------- 9. HERO UNDERLINE DRAW ON LOAD ---------- */
  (function heroUnderline() {
    var copy = $(".hero__copy");
    if (!copy) return;
    // Trigger the underline draw shortly after load.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { copy.classList.add("is-visible"); });
    });
  })();

  /* ---------- 10. HERO PRODUCT 3D TILT (fine pointer only) ---------- */
  (function heroTilt() {
    var product = $("#heroProduct");
    if (!product || prefersReduced) return;
    if (!window.matchMedia || !window.matchMedia("(pointer: fine)").matches) return;
    var hero = product.closest(".hero");
    var img = product.querySelector(".hero__product-img");
    var callouts = product.querySelector(".hero__callouts");
    if (!hero || !img) return;
    var raf = null, rx = 0, ry = 0, cx = 0, cy = 0;
    function apply() {
      raf = null;
      img.style.transform = "rotateX(" + rx.toFixed(2) + "deg) rotateY(" + ry.toFixed(2) + "deg)";
      if (callouts) callouts.style.transform = "translate3d(" + cx.toFixed(1) + "px," + cy.toFixed(1) + "px,0)";
    }
    hero.addEventListener("mousemove", function (e) {
      var r = hero.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width - 0.5;
      var py = (e.clientY - r.top) / r.height - 0.5;
      ry = px * 9; rx = -py * 6;           // group of bottles tilts gently toward the cursor
      cx = px * -16; cy = py * -12;          // callouts drift opposite for depth
      if (!raf) raf = requestAnimationFrame(apply);
    });
    hero.addEventListener("mouseleave", function () {
      rx = ry = cx = cy = 0;
      img.style.transition = "transform .6s var(--ease)";
      if (callouts) callouts.style.transition = "transform .6s var(--ease)";
      apply();
      setTimeout(function () {
        img.style.transition = "";
        if (callouts) callouts.style.transition = "";
      }, 600);
    });
  })();

  /* ---------- 11b. PDP IMAGE GALLERY ---------- */
  (function pdpGallery() {
    var main = $("#pdpMainImg");
    var thumbs = $$(".ls-pdp__thumb");
    if (!main || !thumbs.length) return;

    function show(btn) {
      var src = btn.getAttribute("data-src");
      if (!src) return;
      thumbs.forEach(function (t) { t.classList.toggle("is-active", t === btn); });
      // Let product photos size naturally; the cutout keeps its tall portrait ratio.
      main.removeAttribute("width");
      main.removeAttribute("height");
      main.src = src;
      main.alt = btn.getAttribute("data-alt") || "";
    }

    thumbs.forEach(function (btn) {
      btn.addEventListener("click", function () { show(btn); });
    });
  })();

  /* ---------- 11. PDP QUANTITY STEPPER ---------- */
  (function qtyStepper() {
    $$(".ls-pdp__qty").forEach(function (stepper) {
      var input = $(".ls-pdp__qty-input", stepper);
      if (!input) return;
      // Respect the input's own min (PDP uses min=1; the cart uses min=0 so a line can be removed).
      var floor = parseInt(input.getAttribute("min"), 10);
      if (isNaN(floor)) floor = 1;
      $$(".ls-pdp__qty-btn", stepper).forEach(function (btn) {
        btn.addEventListener("click", function () {
          var delta = parseInt(btn.getAttribute("data-qty"), 10) || 0;
          var val = Math.max(floor, (parseInt(input.value, 10) || floor) + delta);
          input.value = val;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      });
    });
  })();

  /* ---------- 12. CART LIVE UPDATE (progressive enhancement) ---------- */
  (function cartLive() {
    // The cart is a plain form POST (works with no JS via the "Update cart" button). As an
    // enhancement, auto-submit shortly after a quantity change so totals, the free-shipping
    // meter and the checkout amount never sit frozen on stale numbers. Debounced so rapid
    // +/- taps coalesce into one update. A submit with no submitter is treated as an update.
    var form = $("#cartForm");
    if (!form) return;
    var timer = null;
    function scheduleUpdate() {
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () {
        form.classList.add("is-updating");
        form.submit();
      }, 650);
    }
    $$(".ls-cart__qty-input", form).forEach(function (input) {
      input.addEventListener("change", scheduleUpdate);
    });
  })();

})();
